export default {
    'About Us': {
        en: 'About Us',
        es: 'Sobre Nosotros',
        pt: 'Sobre nós'
    },
    'enterDetails': {
        en: 'Enter your credit card details below. We appreciate your contribution.',
        es: 'Ingrese los detalles de su tarjeta de crédito a continuación. Agradecemos tu contribución.',
        pt: 'Insira os dados do seu cartão de crédito abaixo. Agradecemos sua contribuição.'
    },
    'DONATE': {
        en: 'DONATE',
        es: 'DONAR',
        pt: 'DOAR'
    },
    'SUPPORT US': {
        en: 'SUPPORT US',
        es: 'CONTRIBUYE',
        pt: 'CONTRIBUA'
    },
    'supportUsLanding': {
        en: "Música para Respirar 24/7 is a new way of making music in a more personal way. By donating whatever you can, you will help us cover the costs of administration, graphic design and, mainly, the costs of hiring musicians in all of Latin America. Funds raised will be used to help the project reach even more people, many of whom don't have access to classical music.",
        es: "Música para Respirar 24/7 es una nueva forma de hacer música de manera más personal. Contribuye para que llegue a más gente de forma totalmente gratuita. Al apoyarnos estás gestionando el  trabajo de administración, coordinación, diseño gráfico y la contratación de artistas en toda América latina y el mundo.",
        pt: 'Música para Respirar 24/7 é uma nova forma de fazer música muito mais pessoal. Doando qualquer quantia você estará nos ajudando a cobrir os gastos de administração, design gráfico e o mais importante, a contratação de artistas em toda América Latina e no mundo. Os fundos são utilizados para que o projeto alcance ainda mais pessoas, muitas das quais não têm acesso à música clássica.'
    },
    "CLICK HERE": {
        en: "CLICK HERE",
        es: "HAZ CLIC AQUÍ",
        pt: "CLIQUE AQUI"
    },
    "toDonateGoFundMe": {
        en: "To donate through GoFundme",
        es: "Para donar a través de GoFundme",
        pt: "Para doar através do GoFundme",
    },
    "toDonateUSA": {
        en: "For tax deductible donations in the USA",
        es: "Para donaciones deducibles de impuestos en EEUU",
        pt: "Para doações dedutíveis de impostos nos EUA",
    },
      "la música está llamandote": {
      en: "the music is calling you",
      es: "la música está llamandote",
      pt: "a música está chamando você"
    }
}
